import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';

export const StyledContentContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
}));

export const StyledPhoneItemContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '16px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column',
    alignItems: 'unset',
  },
}));

export const StyledDeleteButtonContainer = styled('div')({
  paddingTop: 8,
});

export const StyledPhoneItemTopContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '16px',
}));
